export function odeVmax(lim, lims, comp, crit, od) {
    let subs = lims[1]; 
     if (lim !== 0) {
         subs = lims[lim-1];
     }
     if (comp === 'pomp' || comp === 'tms') {
         if (crit.includes('Intervalo'))  { return [999999, subs]; }
     }
     if (comp !== 'tms')  {
         if (crit === 'Intervalo')  { return [999999, subs]; } 
     }
     let vmax = 82; // ranking, todos os serviços excepto odv e origens
     if (comp === 'odv') { // ranking, serviço odv, origens
         if (od === 'Origem') {
             vmax = 134;
         }
     }
     return [vmax, subs];
 }

export function valid(lim, lims, comp, crit, od, ling) {
    // validação dos limiares fronteira das cores
    // variam com os serviços e com o tipo de limiares (ranking vs intervalo)
    
    let txt = Number.parseInt(lims[lim]);
    let vmin = 0;
    let [vmax, subs] = odeVmax(lim, lims, comp, crit, od);
    subs = Number.parseInt(subs);
    let b = (txt>vmin) && (txt<vmax);
    if (!b 
        || (vmax === 999999 && subs < txt && lim !== 0)
        ||  (vmax === 999999 && subs > txt && lim === 0)
        || (vmax !== 999999 && subs > txt && lim !== 0)
        || (vmax !== 999999 && subs < txt && lim === 0) ) {
        if (ling === 'pt') {
            alert('Limite de -- ' + txt + " -- inaceitável; substituído por " + subs + '.');
        } else {
            alert('-- ' + txt + " -- as a limit is unacceptable; replaced by " + subs + ".");
        }
        return subs;
    }
    return txt;
}  
 
 export function alerta (x, ling, subs) {
    if (ling === 'pt') {
        if (subs === 9999) {
            alert ( x + " inaceitável. Ignorado.");
        } else {
            alert ( x + " inaceitável. Substituído por " + subs);
        }
    } else {
        if (subs === 9999) {
            alert ( x + " unacceptable. Ignored.");
        } else {
            alert ( x + " unacceptable. Replaced by " + subs);
        }
    }
}

export function limpa (lista, inf, sup, ling, subs) {
    var nova = [];
    let jaesta = lista.includes(subs.toString());
    for (let i = 0; i < lista.length; i++) {
        if (Number.isInteger(parseInt(lista[i]))) {
            if (parseInt(lista[i]) < inf || parseInt(lista[i]) > sup) {
                alerta(lista[i], ling, subs);
                if (!jaesta) {
                    nova.push(subs.toString());
                    jaesta = true;
                }
            } else {
                nova.push(parseInt(lista[i]).toString());
            }
        };
    }
    return nova;
}

export function limpaLegenda() {
    if (document.getElementById("pedido") == null) { return};
    document.getElementById("pedido").innerHTML = "Legenda: ";
    document.getElementById("verdescuro").innerHTML = "...";
    document.getElementById("verdeclaro").innerHTML = "...";
    document.getElementById("amarelo").innerHTML = "...";
    document.getElementById("laranja").innerHTML = "...";
    document.getElementById("vermelho").innerHTML = "...";
}

export function limpaloc(lista, ling){
    var nova = [];
    for (let i = 0; i < lista.length; i++) {
        if (Number.isInteger(parseInt(lista[i]))) {
            if (parseInt(lista[i]) < 0 || parseInt(lista[i]) > 226) {
                alerta(lista[i], ling, 9999);
            } else {
                nova.push(lista[i]);
            }
        };
    }
    return nova;
}

export function completaLest(lest, trocos){
    if (trocos.la) { lest.push("Lar") }
    if (trocos.az) { lest.push("Az") }
    if (trocos.verm) { lest.push("Verm") }
    if (trocos.verd) { lest.push("Verd") }
    if (trocos.ptc) { lest.push("tc") }
    if (trocos.viol) { lest.push("Viol") }
    if (trocos.tc) { lest.push("TC") }
    if (trocos.am) { lest.push("Amar") }
    return lest;
}

export function completEst(est, trocos){
    console.log(est, trocos);
    console.log(est);
    if (est.length === 0) est = [];
    if(trocos.la){
        for (let i = 0; i<10; i++) { est.push(i.toString()) }
    }
    if(trocos.az){
        for (let i = 24; i<33; i++) { est.push(i.toString()) }
    }
    if(trocos.ptc){
        for (let i = 33; i<38; i++) { est.push(i.toString()) }
    }
    if(trocos.verm){
        for (let i = 38; i<55; i++) { est.push(i.toString()) }
    }
    if(trocos.tc){
        for (let i = 10; i<24; i++) { est.push(i.toString()) }
    }
    if(trocos.verd){
        for (let i = 55; i<66; i++) { est.push(i.toString()) }
    }
    if(trocos.am){
        for (let i = 66; i<81; i++) { est.push(i.toString()) }
    }
    if(trocos.vi){
        for (let i = 81; i<83; i++) { est.push(i.toString()) }
    }
    console.log(est);
    return est;
}

export function initMap() {
    const google = window.google;
    let map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 41.18, lng: -8.6}, // Porto
        zoom: 11
    });
    return map;
}

export function haEstMP(lista){
    if (!lista) { return false}
    for (let i=0; i<lista.length; i++){
        if (lista[i] < 83) {return true}
    }
    return false
}

export function limparResultados(rows){
    let campo = Object.keys(rows); 
    for (var i=rows.length-1; i>=0; i--){
        if (rows[i][campo[0]] > 82) {
            // elimina esta linha de resultados
            rows.splice(i,1);
        }
    }
    return rows;
}

export function reordena(l1, l2, l3, l4) {
    /*    if(document.getElementById("rank").checked){
            if(l2<l1) { l2 = l1 }
            if(l3<l2) { l3 = l2 }
            if(l4<l3) { l4 = l3 }
        } else {
            if(l2>l1) { l2 = l1 }
            if(l3>l2) { l3 = l2 }
            if(l4>l3) { l4 = l3 }
        } */
        return [l1, l2, l3, l4];
    }

export function desenhaCirc(f, cor, espessura, map){
    const google = window.google;
    let campo = Object.keys(f); 
    let coords = { lat: parseFloat(f[campo[1]]), lng: parseFloat(f[campo[2]]) };
    if (isNaN(coords.lat)) { return ''};
    let latLng = new google.maps.LatLng(coords);
    var circulo = new google.maps.Circle({
        strokeColor:  cor,
        strokeOpacity: 0.8,
        strokeWeight: espessura,
        fillColor:  cor,
        map: map,
        center: latLng,
        radius: 250
    });
    return circulo;
}

export function desenhaQuad (norte, oeste, cor, espessura, map){
    const google = window.google;
    var quadrado = new google.maps.Rectangle({
        strokeColor:  cor,
        strokeOpacity: 0.8,
        strokeWeight: espessura,
        fillColor:  cor,
        map: map,
        bounds: {
            north: norte + 1/220,
            south: norte - 1/220,
            west: oeste - 1/160,
            east: oeste + 1/160
        }
    });
    return quadrado;
}

export function desenhaTro(f, cor, espessura, map) {
    const google = window.google;
    let campo = Object.keys(f); 
    let coordsA = { lat: parseFloat(f[campo[1]]), lng: parseFloat(f[campo[2]]) };
    let latLngA = new google.maps.LatLng(coordsA);
    let coordsB = { lat: parseFloat(f[campo[3]]), lng: parseFloat(f[campo[4]]) };
    let latLngB = new google.maps.LatLng(coordsB);
    var line = new google.maps.Polyline({
        path: [latLngA, latLngB],
        strokeColor: cor,
        strokeOpacity: 1.0,
        strokeWeight: 10,
        map: map
    });
    return line;
}

function toast(message) {
    if (document.querySelector('#menu')) {
        document.querySelector('#menu').style.display = 'none';
    }
    if (document.querySelector('#opt')) {
        document.querySelector('#opt').style.display = 'none';
    }
    var x = document.getElementById("toast");
    x.innerText = message;
    let larg = (window.innerWidth - 32).toString() + 'px';
    x.style.width = larg;
    x.className = "mostra";
}

export function download(csv, ling) {
    console.log(csv);
    if (csv === '') { // se não há nada para mostrar...
        if (ling === 'pt') {
            toast('Necessário fazer uma consulta que produza resultados (botão Colorir) para serem mostrados e gravados!');
        } else {
            toast('Specify a query and then click COLORIR so that results can be shown and recorded for downloading!');
        }
        setTimeout(function() { 
            document.getElementById("toast").classList.remove("mostra"); // apagar o toast
            document.querySelector('#menu').style.display = 'block'; // voltar a mostrar o painel
        }, 6000); // após 6 segundos
        return;
    }
    let fileName = csv;
    console.log(fileName);  
    window.open (fileName,'_blank');
}

export function limpaMapa2 (specs) {
    limpaLegenda();
    document.getElementById('map').style.display = 'none';
    document.getElementById('branco').style.display = 'block';
    let shapes = specs.shapes;
    if (shapes === []) return;
    if (specs.res && specs.res.length > 0) specs.mapa = initMap();
    specs.shapes = [];
    specs.res = null;
    return specs;
}

export const onCritChange2 = (e, s, l, comp)  => {
    s.crit = e.target.value;
    if (e.target.value === 'Ranking') {
        s.lims = [10, 20, 62, 72];
    } else {
        if (comp === 'pomp') {
            s.lims = l['pomp'][parseInt(s.nv)];
        } else {
            s.lims = l[comp];
        }
    }
    return limpaMapa2(s);
}

export const onSpecChange2 = (e, sp, s, l)  => {
    if (sp !== 'nv' && sp !== 'tms') {
        s[sp] = e.target.value;
    } else {
        s['nv'] = e.target.options.selectedIndex;
        if (s.crit === 'Ranking') {
            s.lims = [10, 20, 62, 72];
        } else {
            s.lims = l['pomp'][parseInt(s.nv)];
            if (sp === 'tms') s.lims = l['tms'];
        }
    }
    s = limpaMapa2(s);
    return s;
}

export const onSpecBlur2 = (e, sp, s)  => { 
    s[sp] = e.target.value;
    if (sp !== 'csv' && s.res && s.res.length > 0) return limpaMapa2(s);
    return s;
}

export function cparte2 (p, s){
    s[p] = !s[p];
    return limpaMapa2(s);
}

export function sh2(n, l, s) {
    let specs = limpaMapa2(s);
    if (Number.isInteger(l)) {
        specs.lims[n] = parseInt(l);
    } else {
        specs.lims[n] = l;
    }
    return specs;
}

export function processaResultados(rows, nv, stationAtms, stationBtms) {
    let j = 0;
    let ponto = rows[0];
    let campo = Object.keys(ponto);
    let est, seg;
    let tratados = new Array(83).fill([0, 0, 0]);
    for (let i = 0; i < rows.length; i++) {
      if (nv === 0){ // Sentido AB
        if (rows[i][campo[1]] === 'CSra da Hora') { rows[i][campo[1]] = 'BSra da Hora' }
        if (rows[i][campo[1]] === 'Sra da Hora') { rows[i][campo[1]] = 'BSra da Hora' }
        if (rows[i][campo[1]] === 'EDos Verdes') { rows[i][campo[1]] = 'Dos Verdes'}
        est = pos(rows[i][campo[0]], stationAtms);
        seg = pos(rows[i][campo[1]], stationBtms);
        if (est === 999) { 
            console.log(rows[i]);
            continue;
        }
        if (est === 23 && seg === 32) { est = 32 }
        if (est === 23 && seg === 53) { est = 53 }
        if (est === 33 && seg === 54) { est = 54 }
        if (est === 37 && seg === 79) { est = 79 }
        if (est === 82 && seg === 42) { est = 42 }
        if (seg === est) {
            tratados[j] = [est, seg, rows[i][campo[2]]];
            j++;
        }
      } else { // Sentido BA
        if (rows[i][campo[1]] === 'Casa da Musica') { rows[i][campo[1]] = 'Casa da Música'}
        if (rows[i][campo[0]] === 'Casa da Música') { rows[i][campo[0]] = 'Casa da Musica'}
        if (rows[i][campo[1]] === 'Bolhao') { rows[i][campo[1]] = 'Bolhão'}
        if (rows[i][campo[0]] === 'Bolhão') { rows[i][campo[0]] = 'Bolhao'}
        if (rows[i][campo[1]] === 'Campanha') { rows[i][campo[1]] = 'Campanhã'}
        if (rows[i][campo[0]] === 'Campanhã') { rows[i][campo[0]] = 'Campanha'}
        if (rows[i][campo[1]] === 'Estadio do Dragao') { rows[i][campo[1]] = 'Estádio do Dragão'}
        if (rows[i][campo[0]] === 'Estádio do Dragão') { rows[i][campo[0]] = 'Estadio do Dragao'}
        if (rows[i][campo[1]] === 'Estadio do Mar') { rows[i][campo[1]] = 'Estádio do Mar'}
        if (rows[i][campo[0]] === 'Estádio do Mar') { rows[i][campo[0]] = 'Estadio do Mar'}
        if (rows[i][campo[1]] === 'Joao de Deus') { rows[i][campo[1]] = 'João de Deus'}
        if (rows[i][campo[0]] === 'João de Deus') { rows[i][campo[0]] = 'Joao de Deus'}
        if (rows[i][campo[1]] === 'Sao Bento') { rows[i][campo[1]] = 'São Bento'}
        if (rows[i][campo[0]] === 'São Bento') { rows[i][campo[0]] = 'Sao Bento'}
        if (rows[i][campo[1]] === 'D. Joao II') { rows[i][campo[1]] = 'D.João II'}
        if (rows[i][campo[0]] === 'D.João II') { rows[i][campo[0]] = 'D. Joao II'}
        if (rows[i][campo[1]] === 'Combatentes') { rows[i][campo[1]] = 'Lima'}
        if (rows[i][campo[0]] === 'Lima') { rows[i][campo[0]] = 'Combatentes'}
        if (rows[i][campo[1]] === 'Hospital S. Joao') { rows[i][campo[1]] = 'São João'}
        if (rows[i][campo[0]] === 'São João') { rows[i][campo[0]] = 'Hospital S. Joao'}
        if (rows[i][campo[1]] === 'BFonte do Cuco') { rows[i][campo[1]] = 'Fonte do Cuco'}
        if (rows[i][campo[0]] === 'Fonte do Cuco') { rows[i][campo[0]] = 'BFonte do Cuco'}
        if (rows[i][campo[1]] === 'CFonte do Cuco') { rows[i][campo[1]] = 'Fonte do Cuco'}
        if (rows[i][campo[0]] === 'Fonte do Cuco') { rows[i][campo[0]] = 'CFonte do Cuco'}
        if (rows[i][campo[1]] === 'BSra da Hora') { rows[i][campo[1]] = 'Sra da Hora'}
        if (rows[i][campo[0]] === 'Sra da Hora') { rows[i][campo[0]] = 'BSra da Hora'}
        if (rows[i][campo[1]] === 'CSra da Hora') { rows[i][campo[1]] = 'Sra da Hora'}
        if (rows[i][campo[0]] === 'Sra da Hora') { rows[i][campo[0]] = 'CSra da Hora'}
        if (rows[i][campo[1]] === 'CSra da Hora') { rows[i][campo[1]] = 'Sra da Hora'}
        if (rows[i][campo[0]] === 'Sra da Hora') { rows[i][campo[0]] = 'CSra da Hora'}
        if (rows[i][campo[1]] === 'EDos Verdes') { rows[i][campo[1]] = 'Dos Verdes'}
        if (rows[i][campo[1]] === 'Custio') { rows[i][campo[1]] = 'Custió'}
        if (rows[i][campo[0]] === 'Custió') { rows[i][campo[0]] = 'Custio'}
        if (rows[i][campo[1]] === 'Araujo') { rows[i][campo[1]] = 'Araújo'}
        if (rows[i][campo[0]] === 'Araújo') { rows[i][campo[0]] = 'Araujo'}
        if (rows[i][campo[1]] === 'Arvore') { rows[i][campo[1]] = 'Árvore'}
        if (rows[i][campo[0]] === 'Árvore') { rows[i][campo[0]] = 'Arvore'}
        if (rows[i][campo[1]] === 'Candido dos Reis') { rows[i][campo[1]] = 'Cândido dos Reis'}
        if (rows[i][campo[0]] === 'Cândido dos Reis') { rows[i][campo[0]] = 'Candido dos Reis'}
        if (rows[i][campo[1]] === 'Espaco Natureza') { rows[i][campo[1]] = 'Espaço Natureza'}
        if (rows[i][campo[0]] === 'Espaço Natureza') { rows[i][campo[0]] = 'Espaco Natureza'}
        if (rows[i][campo[1]] === 'Alto da Pega') { rows[i][campo[1]] = 'Alto da Pêga'}
        if (rows[i][campo[0]] === 'Alto da Pêga') { rows[i][campo[0]] = 'Alto da Pega'}
        if (rows[i][campo[1]] === 'Castelo da Maia') { rows[i][campo[1]] = 'Castêlo da Maia'}
        if (rows[i][campo[0]] === 'Castêlo da Maia') { rows[i][campo[0]] = 'Castelo da Maia'}
        if (rows[i][campo[1]] === 'Fanzeres') { rows[i][campo[1]] = 'Fânzeres'}
        if (rows[i][campo[0]] === 'Fânzeres') { rows[i][campo[0]] = 'Fanzeres'}
        if (rows[i][campo[1]] === 'Santo Ovidio') { rows[i][campo[1]] = 'Santo Ovídio'}
        if (rows[i][campo[0]] === 'Santo Ovídio') { rows[i][campo[0]] = 'Santo Ovidio'}
        est = pos(rows[i][campo[0]], stationBtms);
        seg = pos(rows[i][campo[1]], stationAtms);
        if (est === 999) { 
            console.log(rows[i]);
            continue;
        }
        if (est === 32 && seg === 23) { seg = 32 }
        if (est === 23 && seg === 53) { est = 53 }
        if (est === 54 && seg === 33) { seg = 54 } // Cândido do Reis - Fonte do Cuco
        if (est === 79 && seg === 37) { seg = 79 } // Boticas - Verdes
        if (est === 42 && seg === 81) { seg = 42 }
        if (est === 81 && seg === 43) { seg = 81 } // Modivas Norte - Modivas Centro
        if (est === 42 && seg === 82) { est = 82 } // Mindelo - Modivas Norte
        if (seg === est) {
            tratados[j] = [est, seg, rows[i][campo[2]]];
            console.log(est, seg, rows[i][campo[2]]);
            j++;
        }
      }
    }
    return tratados;
}

function pos(nome, lista) {
    if (!lista) return 999;
    for (let i = 0; i < lista.length; i++) {
      if (nome === lista[i]) { return i}
    }
    return 999;
}

export function desenhaTroTms(coords, tro, cor, map){
    let k = tro[0];
    let coordsB = { lng: parseFloat((coords[k][3])), 
                    lat: parseFloat((coords[k][2])) };
    let latLngB = new window.google.maps.LatLng(coordsB);
    let coordsA = { lng: parseFloat((coords[k][1])), 
                    lat: parseFloat((coords[k][0])) };
    let latLngA = new window.google.maps.LatLng(coordsA);
    var line = new window.google.maps.Polyline({
        path: [latLngA, latLngB],
        strokeColor: cor,
        strokeOpacity: 1.0,
        strokeWeight: 10,
        map: map
    });
    return line;
}